<sub-header [isModal]="true" [windowHash]=windowHash [includeContextHelp]="false"></sub-header>
<p-scrollPanel [style]="{width: '100%', height: '60vh'}" styleClass="custombar1">
  <div class="container-fluid ">
    <div class="row pt-5" *ngIf="loaded">
      <!--
      <div class="col-12 alert alert-info">
        <span> <i class="fas fa-1-5x fa-info-circle m-r-md"
            aria-hidden="true"></i>{{'DossierLinks.situation.message.info' | translate}}</span>
      </div>
-->
      <div class="col-6">
        <dl>
          <ng-container *ngIf="model.procedure">
            <dt>{{ 'Actions.setVariables.dossier' | translate }}</dt>
            <dd>{{ model.division.project.contractFolderId }}</dd>
            <dt>{{ 'Actions.setVariables.task' | translate }}</dt>
            <dd>{{ model.identifier }}</dd>
            <dt>{{ 'Actions.setVariables.procedure' | translate }}</dt>
            <dd>{{ model.procedure.identifier }}</dd>
          </ng-container>
          <ng-container *ngIf="!(model.procedure)">
            <dt>{{ 'Actions.setVariables.dossier' | translate }}</dt>
            <dd>{{ model.division.project.contractFolderId }}</dd>
            <dt>{{ 'Actions.setVariables.definition' | translate }}</dt>
            <dd>{{ model.definition.identifier }}</dd>
          </ng-container>
        </dl>
      </div>
      <div class="col-6">
        <dl>
          <ng-container *ngIf="model.procedure">
            <dt>{{ 'Actions.setVariables.process' | translate }}</dt>
            <dd>{{ model.procedure.processIdentifier }}</dd>
            <dt>{{ 'Actions.setVariables.definition' | translate }}</dt>
            <dd>{{ model.procedure.definition.identifier }}</dd>
          </ng-container>
          <ng-container *ngIf="!(model.procedure)">
            <dt>{{ 'Actions.setVariables.process' | translate }}</dt>
            <dd>{{ model.processIdentifier }}</dd>
            <dt>{{ 'Actions.setVariables.procedure' | translate }}</dt>
            <dd>{{ model.identifier }}</dd>
          </ng-container>
        </dl>
      </div>
    </div>
    <div class="row">
      <wait-component></wait-component>
      <div class="col-12">
        <formPlyca #formPlycaRef [formConfig]="formConfig" *ngIf="formConfig" [manageWaitService]=false>
        </formPlyca>
      </div>
    </div>
  </div>
</p-scrollPanel>